





















































































import { Vue, Component, Prop } from 'vue-property-decorator';
import PhoneMockup from '@/componentsV2/molecules/PhoneMockupV2/PhoneMockup.vue';
import { pluralize } from '@/utils';
import HeartOutlineIcon from '@/components/icons/HeartOutline.vue';
import Arrow from '@/components/icons/Arrow.vue';
import { getLabelInfo } from '@/utils/getLabelInfo';
import { ILocation } from '@/models/location';
import LazyImage from '@/componentsV2/atoms/LazyImage/LazyImage.vue';

@Component({
  components: {
    PhoneMockup,
    HeartOutlineIcon,
    Arrow,
    LazyImage
  }
})
export default class AppBusinessInfo extends Vue {
  @Prop() data!: any;

  get locationsText() {
    return `View ${this.data.locations.length} ${pluralize(
      this.data.locations.length,
      'Location'
    )}`;
  }

  get locationText() {
    return this.getFullAddress(this.data.locations[0]);
  }

  get imageSrc() {
    return require(`@/assets/img/image-placeholder.png`);
  }

  get logoSrc() {
    return this.data.logo.publicPath.small;
  }

  getFullAddress(location: ILocation) {
    return getLabelInfo(
      ['address', 'addressAdditional', 'city', 'state', 'zip'],
      location
    );
  }

  getOffersByLocation(location: ILocation) {
    return this.data.offers.filter((offer: any) =>
      offer.locations.find(
        (offerLocation: any) => offerLocation.id === location.id
      )
    );
  }
}
